import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from './components/ThemeProvider';
import { PermissionDeniedHandler } from '@/core/permissions';
import { AppProviders } from '@/core/providers/AppProviders';
import { AuthProvider } from '@/features/auth';
import { SchoolLockHandler } from '@/features/billing';
import App from './App';

import './i18n';
import './index.css';

// The router lives HERE (FE-ADR-003) — providers are router-agnostic except
// AuthProvider, which needs useNavigate and therefore mounts inside it.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AppProviders>
          <AuthProvider>
            {/* Global 402 `school_locked` router — see SchoolLockHandler. */}
            <SchoolLockHandler />
            {/* Global 403 seam for refused writes — see PermissionDeniedHandler. */}
            <PermissionDeniedHandler />
            <App />
          </AuthProvider>
        </AppProviders>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
